import * as Types from './types';
var initialState = {
    show: false,
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Types.SHOW_LOADER:
            return {
                show: action.show,
            };
    }
    return state;
};
export default reducer;
